/*******************************************************************************
Documentation Actions

*******************************************************************************/
import { SET_DOCS } from './types';
//import { ROOT_URL } from '../../constants';
//const Materialize = window.Materialize;


export function setDocs(docType) {
  return {
    type: SET_DOCS,
    payload: docType
  }
}
/*
function error(err) {
  Materialize.toast(err, 4000, 'rounded red');
  return {
    type: ERROR,
    err
  };
}*/










/* END */



// WEBPACK FOOTER //
// ./src/cultivation/actions/docs_actions.js